import { render } from "./access-denied-modal.html?vue&type=template&id=3b65005a&scoped=true&ts=true&external"
import script from "./access-denied-modal.ts?vue&type=script&lang=ts&external"
export * from "./access-denied-modal.ts?vue&type=script&lang=ts&external"

import "./access-denied-modal.scss?vue&type=style&index=0&id=3b65005a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b65005a"]])

export default __exports__